export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8353.f651af8d.jpg";